import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f213e8ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./styles/reset.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./styles/main.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./App.vue?vue&type=style&index=2&id=f213e8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports